import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterKorat extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterTuesday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>AIKIDO KORAT's MEMBERS</h3>
      <br />
      <br />

      <div><Link to='/conduct-witchayapongp'>1. AAT  6032  MR.WITCHAYAPONG  PIYATHANYANON(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-surink'>2. AAT  7801  MR.SURIN KAMMANEE(A)</Link></div>
      <br />
      <div><Link to='/conduct-narongritn'>3. AAT  7804  MR.NARONGRIT NARTSUNGNOEN(A)</Link></div>
      <br />
      <div><Link to='/conduct-paramir'>4. AAT  7823  MR.PARAMI  RINGKRATHOK(A)</Link></div>
      <br />
      <div><Link to='/conduct-patanins'>5. AAT  7805  MR.PATANIN SIRIPRU(A)</Link></div>
      <br />
      <div><Link to='/conduct-salineeb'>6. AAT  7974  MS.SALINEE BOWONRATTANAPAT(A)</Link></div>
      <br />
      <div><Link to='/conduct-thornthepk'>7. AAT  8108  MR.THORNTHEP KHRAIKHRUAN(A)</Link></div>
      <br />
      <div><Link to='/conduct-tirawutn'>8. AAT  8109  MR.TIRAWUT NORKHUNTOD(A)</Link></div>
      <br />
      <div><Link to='/conduct-phanuphongk'>9. AAT  8111  MR.PHANUPHONG KHETKRATHOK(A)</Link></div>
      <br />
      <div><Link to='/conduct-new'>10. AAT  7802  MR.NE  WILAIPAN(A)</Link></div>
      <br />
      <div><Link to='/conduct-jiaminb'>11. AAT  7807  MS.JIAMIN BI(A)</Link></div>

        <br />
        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterKorat;
